import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingWdylMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Object} param.data.filters
   * @param {String} param.data.make
   * @param {String} param.data.model
   */
  map({page, culture, data}) {
    const {filters, make, model} = data

    const trackingData = {}

    if (filters && filters.keywords) {
      trackingData.filters = filters
      trackingData.keywords = filters.keywords
      trackingData.event_name = 'ad_filter'
    }

    if (make) trackingData.page_category_level2 = make

    if (model) trackingData.page_category_level3 = model

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
